import React from "react";

const ProductGroupItem = ({
    group,
    selected,
    onClick
}) => {

    const groupId =
        group?.id ??
        group?.ID ??
        group?.groupId;

    const groupName =
        group?.name ??
        group?.Name ??
        group?.groupName ??
        group?.GroupName ??
        "-";

    const handleClick = () => {
        if (typeof onClick === "function") {
            onClick(groupId);
        }
    };

    return (
        <button
            type="button"
            className={
                `product-group-item ${
                    selected
                        ? "product-group-item-selected"
                        : ""
                }`
            }
            onClick={handleClick}
            title={groupName}
        >
            <span className="product-group-item-text">
                {groupName}
            </span>
        </button>
    );
};

export default ProductGroupItem;
